'use client';
import Select from '@/components/select';
import { useState } from 'react';
import { useEffect } from 'react';
import { Series } from 'types';

export default function PopularSeries({
  onSelectSeries,
  series,
  selectedSeries,
}: {
  onSelectSeries: (series: Series) => void;
  series: Series[];
  selectedSeries: Series;
}) {
  const [popularSeries, setPopularSeries] = useState<Series[]>([]);

  useEffect(() => {
    setPopularSeries(series);
  }, [series]);

  const handleSeriesChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedSeries: Series = series.find(
      (s) => s.seriesTitle === event.target.value
    );
    if (selectedSeries) {
      onSelectSeries(selectedSeries);
    }
  };

  return (
    <Select
      options={popularSeries.map((series) => ({
        name: series.seriesTitle,
        value: series.seriesTitle,
      }))}
      value={selectedSeries?.seriesTitle || popularSeries[0]?.seriesTitle}
      onChange={handleSeriesChange}
      transparent={false}
      hideArrow={false}
      required={false}
    />
  );
}
